<template>
  <div class="promo-area">
    <h3 class="promo-section-header forza-bold">trusted brands</h3>
    <div class="promo-area-content">
      <component :is="componentName"></component>
    </div>
  </div>
</template>

<script>
import FSGPromoArea from "@/components/Projects/Playbooks/Index/FSGPromoArea.vue";
import UAPromoArea from "@/components/Projects/Playbooks/Index/UAPromoArea.vue";
import { mapGetters, mapState } from "vuex";

export default {
  name: "PromoArea",
  computed: {
    ...mapState("playbook", ["template"]),
    ...mapGetters("playbook", ["isUATemplate"]),
    componentName() {
      return this.isUATemplate ? "UAPromoArea" : "FSGPromoArea";
    },
  },
  components: {
    FSGPromoArea,
    UAPromoArea,
  },
};
</script>

<style lang="scss" scoped>
.promo-section-header{
  background-color: #333;
  color: white;
  padding: .5em;
  text-align: left;
  font-family: "ForzaBold";
  text-transform: uppercase;
  font-size: 1.75em;
  margin-bottom: 1em;
}
</style>
